import request from '@/utils/request'


// 查询询价出价记录列表
export function listActivityChujia(query) {
  return request({
    url: '/activityChujia/activityChujia/list',
    method: 'get',
    params: query
  })
}

// 查询询价出价记录分页
export function pageActivityChujia(query) {
  return request({
    url: '/activityChujia/activityChujia/page',
    method: 'get',
    params: query
  })
}

// 查询询价出价记录详细
export function getActivityChujia(data) {
  return request({
    url: '/activityChujia/activityChujia/detail',
    method: 'get',
    params: data
  })
}

// 新增询价出价记录
export function addActivityChujia(data) {
  return request({
    url: '/activityChujia/activityChujia/add',
    method: 'post',
    data: data
  })
}

// 修改询价出价记录
export function updateActivityChujia(data) {
  return request({
    url: '/activityChujia/activityChujia/edit',
    method: 'post',
    data: data
  })
}

// 删除询价出价记录
export function delActivityChujia(data) {
  return request({
    url: '/activityChujia/activityChujia/delete',
    method: 'post',
    data: data
  })
}

// 查询询价出价记录分页
export function mybidpage(query) {
  return request({
    url: '/activityChujia/activityChujia/mybidpage',
    method: 'get',
    params: query
  })
}
// 查询询价出价记录分页
export function myplatbidpage(query) {
  return request({
    url: '/activityChujia/activityChujia/myplatbidpage',
    method: 'get',
    params: query
  })
}
